import React from 'react';
import classes from './ConverterMainSection.module.css';

const ConverterMainSection = () => {
  return <div className={`${classes.BgImg}`}></div>;
};

export default ConverterMainSection;
